import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TopNavigation.css';
import logoImage from './logo.png';
import searchIcon from './search_icon_search.svg';
// import LanguageSwitcher from './LanguageSwitcher';
import NavigationMenu from './components/NavigationMenu';
import navigationConfig from './config/navigationConfig';

const TopNavigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // 处理滚动事件
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 处理导航项点击
  const handleNavItemClick = (e) => {
    setIsMobileMenuOpen(false);
  };

  // 添加外部点击监听
  useEffect(() => {
    // 处理菜单外点击
    const handleOutsideClick = (e) => {
      if (isMobileMenuOpen && !e.target.closest('.mobile-menu') && !e.target.closest('.hamburger')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isMobileMenuOpen]);

  // 切换移动端菜单
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`top-navigation ${isScrolled ? 'scrolled' : ''}`}>
        <Link to="/" className="logo-container">
          <div className="logo-text">
            <span className="logo-main">Straits Strategy</span>
            <span className="logo-sub">Group</span>
          </div>
        </Link>
        
        {/* 桌面版导航菜单 */}
        <NavigationMenu 
          menuItems={navigationConfig}
          variant="desktop"
          onItemClick={handleNavItemClick}
        />

        <div className="nav-icons-container">
          {/* <div className="nav-language-switcher">
            <LanguageSwitcher />
          </div> */}
          <div className="nav-hamburger-icon">
            <div className="hamburger" onClick={toggleMobileMenu}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div className="nav-search-icon" style={{ display: 'none' }}>
            <a href="#search" onClick={handleNavItemClick} className="icon-button">
              <img src={searchIcon} alt="Search" className="search-icon" />
            </a>
          </div>
        </div>
      </nav>

      {/* 移动端侧边栏菜单 */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <NavigationMenu 
            menuItems={navigationConfig}
            variant="mobile"
            onItemClick={handleNavItemClick}
          />
        </div>
      </div>
    </>
  );
};

export default TopNavigation;
